var store = {

    idleTime: 0,
    timeOut: 0,
    intervalTypes: {},
    getStoreItem: function (context, options, asyncRequest, saveToSession, forceCall, callback) {
        var item = null;

        switch (context) {

            //Cause
            case enums.modelsEnum.CAUSE:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.CAUSE + "-" + options.ID);
                if (item == null) {
                    var Account = require("models/causes/cause");
                    var itemModel = new Account({ ID: options.ID });
                    var that = this;
                    itemModel.fetch({
                        async: asyncRequest,
                        success: function (model, resp) {
                            if (saveToSession) that.setStoreItem(context, { ID: options.ID, Data: model.toJSON() });
                            if (callback) {
                                callback(model);
                            }
                        }
                    })
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }            
                break;

            case enums.modelsEnum.PostDetail:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.PostDetail + "-" + options.ID);
                if (item == null) {
                    var Posts = require("models/activities/posts/postitem");
                    var itemModel = new Posts({ PGID: options.ID , showFlaggedItems: options.showFlaggedItems});
                    var that = this;
                    itemModel.fetch({
                        async: asyncRequest,
                        success: function (model, resp) {
                            if (saveToSession) that.setStoreItem(context, { ID: options.ID, Data: model.toJSON(), showFlaggedItems: options.showFlaggedItems });
                            if (callback) {
                                callback(model.toJSON());
                            }
                        }
                    })
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;

            //Comments
            case enums.modelsEnum.Comments:
                if (item == null) {
                    var Comments = require('models/messages/comments_collection');
                    var itemCollection = new Comments(null, { PPGD: options.PPGD, parse: options.parse, length: options.length, incLatest: options.incLatest, showFlaggedItems: options.showFlaggedItems, retainCount: options.retainCount });
                    itemCollection.fetch({
                        async: asyncRequest,
                        success: function (model, resp) {
                            if (callback) {
                                callback(model);
                            }
                        }
                    })
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;

            //News
            case enums.modelsEnum.Posts:
                if (item == null) {
                    //var News = require("models/activities/posts/post_collection");

                    require(['models/activities/posts/post_collection'], function (Posts) {
                        var itemCollection = new Posts(null, { instanceURL: options.instanceURL, panel: options.panel, PageNumber: options.PageNumber, count: options.count, accountGUID: options.accountGUID, postCategoryID: options.postCategoryID });
                        itemCollection.fetch({
                            async: asyncRequest,
                            success: function (model, resp) {
                                if (callback) {
                                    callback(model);
                                }
                            }
                        })
                    });

                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;

            case enums.modelsEnum.CAUSESETTINGS:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.CAUSESETTINGS + "-" + options.ID);
                if (item == null) {
                    var CauseSettings = require("models/shared/settings/settingvalue_collection");
                    var itemCollection = new CauseSettings({ ID: options.ID });
                    var that = this;
                    itemCollection.fetch({
                        async: asyncRequest,
                        success: function (model, resp) {
                            if (saveToSession) that.setStoreItem(context, { ID: options.ID, Data: model.toJSON() });
                            if (callback) {
                                callback(model);
                            }
                        }
                    })
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;


            case enums.modelsEnum.CurrentContext:
                var item = sessionStorage.getItem(enums.modelsEnum.CurrentContext);//enums.HelpContext
                if (callback) {
                    callback(item);
                }
                break;

            case enums.modelsEnum.campaign:
                var item = sessionStorage.getItem(enums.modelsEnum.campaign);
                if (callback) {
                    callback(item);
                }
                break;
            case enums.modelsEnum.ReferralCode:
                var item = sessionStorage.getItem(enums.modelsEnum.ReferralCode);
                if (callback) {
                    callback(item);
                }
                break;

            case enums.modelsEnum.EmailVerificationPassed:
                var item = sessionStorage.getItem(enums.modelsEnum.EmailVerificationPassed);
                if (callback) {
                    callback(item);
                }
                break;
            case enums.modelsEnum.IsRegistration:
                var item = sessionStorage.getItem(enums.modelsEnum.IsRegistration);
                if (callback) {
                    callback(item);
                }
                break;

            //ConsumerAccounts
            case enums.modelsEnum.ConsumerAccounts:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.ConsumerAccounts);
                if (item == null) {
                    require(['models/causes/cause_collection'], function (ConsumerAccounts) {
                        var itemCollection = new ConsumerAccounts();
                        itemCollection.fetch({
                            url: pf.consumerURL + "/Accounts/Mgr",
                            async: asyncRequest,
                            success: function (model, resp) {
                                if (callback) {
                                    callback(model);
                                }
                            }
                        })
                    });

                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;
              
            //Merchant
            case enums.modelsEnum.Merchant:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.Merchant + "-" + options.GUID);
                      if (callback) {
                        callback(JSON.parse(item));
                    }                
                      break;
            //Merchants
            case enums.modelsEnum.Merchants:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.Merchants + "-" + options.ID);
                if (item == null) {
                    var Merchants = require("models/merchant/merchant_collection");
                    var itemsCollection = new Merchants({ ID: options.ID });
                    var that = this;
                    itemsCollection.fetch({
                        async: asyncRequest,
                        success: function (model, resp) {
                            if (saveToSession) that.setStoreItem(context, { ID: options.ID, Data: model.toJSON() });
                            if (callback) {
                                callback(model);
                            }
                        }
                    })
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;

            //UserInfo
            case enums.modelsEnum.UserInfo:
                if (!forceCall) item = sessionStorage.getItem(enums.modelsEnum.UserInfo + "-" + options.ID);
                if (item == null) {
                    var that = this;
                    require(["models/shared/user/user"], function (User) {
                        var itemModel = new User({ instanceURL: pf.consumerURL + "/Info" });                       
                        itemModel.fetch({
                            async: asyncRequest,
                            success: function (model, resp) {
                                if (saveToSession) that.setStoreItem(context, { ID: options.ID, Data: model.toJSON() });
                                if (callback) {
                                    callback(itemModel.toJSON());
                                }
                            }
                        })
                    });                   
                }
                else {
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                }
                break;
                //FinancialRegInfo
            case enums.modelsEnum.FinMbrApplication:
                item = sessionStorage.getItem(enums.modelsEnum.FinMbrApplication + "-" + pf.session.get("UserGUID"));
                    if (callback) {
                        callback(JSON.parse(item));
                    }
                
                    break;
            case enums.modelsEnum.SignUpEmailAddress:
                var item = sessionStorage.getItem(enums.modelsEnum.SignUpEmailAddress);
                if (callback) {
                    callback(item);
                }
                break;
            case enums.modelsEnum.AffiliateUrl:
                var item = sessionStorage.getItem(enums.modelsEnum.AffiliateUrl);
                if (callback) {
                    callback(item);
                }
                break;
        };
    },
    setStoreItem: function (context, options) {
        switch (context) {
            case enums.modelsEnum.CAUSE:
                sessionStorage.setItem(enums.modelsEnum.CAUSE + "-" + options.ID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.CAUSESETTINGS:
                sessionStorage.setItem(enums.modelsEnum.CAUSESETTINGS + "-" + options.ID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.CurrentContext:
                sessionStorage.setItem(enums.modelsEnum.CurrentContext, options.Data);
                break;
            case enums.modelsEnum.campaign:
                sessionStorage.setItem(enums.modelsEnum.campaign, options.Data);
                break;
            case enums.modelsEnum.ReferralCode:
                sessionStorage.setItem(enums.modelsEnum.ReferralCode, options.Data);
                break;
            case enums.modelsEnum.Merchant:
                sessionStorage.setItem(enums.modelsEnum.Merchant + "-" + options.GUID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.PostDetail:
                sessionStorage.setItem(enums.modelsEnum.PostDetail + "-" + options.ID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.Merchants:
                sessionStorage.setItem(enums.modelsEnum.Merchants + "-" + options.ID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.UserInfo:
                sessionStorage.setItem(enums.modelsEnum.UserInfo + "-" + options.ID, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.FinMbrApplication:
                sessionStorage.setItem(enums.modelsEnum.FinMbrApplication + "-" + pf.session.get("UserGUID"), JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.ConsumerAccounts:
                sessionStorage.setItem(enums.modelsEnum.ConsumerAccounts, JSON.stringify(options.Data));
                break;
            case enums.modelsEnum.EmailVerificationPassed:
                sessionStorage.setItem(enums.modelsEnum.EmailVerificationPassed, options.Data);
                break;
            case enums.modelsEnum.IsRegistration:
                sessionStorage.setItem(enums.modelsEnum.IsRegistration, options.Data);
                break;
            case enums.modelsEnum.SignUpEmailAddress:
                sessionStorage.setItem(enums.modelsEnum.SignUpEmailAddress, options.Data);
                break;
            case enums.modelsEnum.AffiliateUrl:
                sessionStorage.setItem(enums.modelsEnum.AffiliateUrl, options.Data);
                break;
        };
    },

    setStoreItemTimer: function (context, options, timeOut) {        
        this.setStoreItem(context, options);
        var that = this;
        that.timeOut = timeOut;
        //var closeConfirm;
        that.intervalTypes[context] = setInterval(function () {
            that.idleTime = that.idleTime + 1;
            if (that.idleTime > (that.timeOut - 1)) {
                //that.removeStoreItem(context, options);
                clearInterval(that.intervalTypes[context]);
                //window.confirm = function () {
                //    window.confirm = closeConfirm;
                //    return false;
                //};
                //pf.popupboxclose();
            }
            else if (that.idleTime == (that.timeOut - 2)) {
                //closeConfirm = confirm("Do you wish to continue..\nPress ok to continue or cancel to exit");
                //if (closeConfirm == true) {
                //    that.idleTime = 0;
                //} else {
                //    that.removeStoreItem(context, options);
                //    clearInterval(that.intervalTypes[context]);
                 //   pf.popupboxclose();
                //}
            }
        }, 60000);
    },
    removeStoreItem: function (context, options) {
        switch (context) {
            case enums.modelsEnum.CAUSE:
                sessionStorage.removeItem(enums.modelsEnum.CAUSE + "-" + options.ID);
                break;
            case enums.modelsEnum.CAUSESETTINGS:
                sessionStorage.removeItem(enums.modelsEnum.CAUSESETTINGS + "-" + options.ID);
                break;
            case enums.modelsEnum.PostDetail:
                sessionStorage.removeItem(enums.modelsEnum.PostDetail + "-" + options.ID);
                break;
            case enums.modelsEnum.FinMbrApplication:
                sessionStorage.removeItem(enums.modelsEnum.FinMbrApplication + "-" + pf.session.get("UserGUID"));
                break;
            case enums.modelsEnum.ConsumerAccounts:
                sessionStorage.removeItem(enums.modelsEnum.ConsumerAccounts);
                break;
            case enums.modelsEnum.ReferralCode:
                sessionStorage.removeItem(enums.modelsEnum.ReferralCode);
                break;
            case enums.modelsEnum.IsRegistration:
                sessionStorage.removeItem(enums.modelsEnum.IsRegistration);
                break;
            case enums.modelsEnum.SignUpEmailAddress:
                sessionStorage.removeItem(enums.modelsEnum.SignUpEmailAddress);
                break;
            default:
                sessionStorage.clear();
                break;
        };
    },

    getLocalItem: function (context, options, asyncRequest, saveToSession, forceCall, callback) {
        var item = null;

        switch (context) {
        };
    },
    setLocalItem: function (context, options) {
        switch (context) {
            
        };
    },
    removeLocalItem: function (context, options) {
        switch (context) {
            
        };
    }
};
define("common/models", function(){});

